import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { useApi } from 'hooks';
import { CreateCitizenResponse, ISearchClient } from '../../../../api-service/clients/auto-generated-clients';
import { Button } from '../../../../components/button/button';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { useRowActions } from '../../../search/contextProviders/row-action-provider';
import { useNotifier } from '../../../../components/notifier/notifier-context';
import { deconstructError, isAuthError } from '../../../../utilities/error-helper';

export interface CreateCitizenButtonProps {
  cpr: string | undefined;
}
const useStyles = makeStyles()((theme: Theme) =>
  ({
    createCitizenButton: {
      width: 'fit-content',
      marginTop: theme.spacing(2),
    },
    createCitizenIcon: {
      marginRight: theme.spacing(1),
    },
  })
);

export function CreateCitizenButton(props: CreateCitizenButtonProps): JSX.Element {
  const { cpr } = props;
  const { classes } = useStyles();
  const rowActions = useRowActions();
  const { dispatch } = useNotifier();
  const [submitting, setSubmitting] = useState<boolean>(false);

  const searchClient: ISearchClient = moduleClientFactory.createSearchClient(true);
  const createCitizenApi = useApi(cancelToken => searchClient.createCitizen({ cpr }, cancelToken), {} as CreateCitizenResponse);

  function handleCreateCitizen() {
    setSubmitting(true);

    createCitizenApi.invoke();
  }

  useEffect(() => {
    if (!createCitizenApi?.result?.citizenId) {
      return;
    }

    setSubmitting(false);

    const rowAction = rowActions?.find(x => x.resultType.toLowerCase() === 'citizen');
    const res = createCitizenApi.result;
    if (res.citizenId && rowAction && rowAction.url) {
      const url = rowAction.url.replace('{record.guid}', res.citizenId);
      window.open(url, rowAction.resultType + res.citizenId);
    }
  }, [createCitizenApi.result, rowActions]);

  useEffect(() => {
    if (!createCitizenApi.error) {
      return;
    }

    setSubmitting(false);

    const err = createCitizenApi.error;

    if (isAuthError(err)) {
      dispatch({ type: 'notify', payload: deconstructError(err) });
    }
  }, [createCitizenApi.error, dispatch]);

  return (
    <Button loading={submitting} onClick={handleCreateCitizen} color="primary" variant="outlined" className={classes.createCitizenButton}>
      <FontAwesomeIcon className={classes.createCitizenIcon} icon={faPlus} />
      Opret
    </Button>
  );
}
